document.addEventListener('DOMContentLoaded', function () {
  const cartPopup = document.querySelector('.quick-cart');
  let lastFocusedElement = null;

  if (!cartPopup) return;

  cartPopup.setAttribute('tabindex', '-1');

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === 'class') {
        const isActive = cartPopup.classList.contains('is-active');

        if (isActive) {
          lastFocusedElement = document.activeElement;
          cartPopup.focus();
        } else {
          if (lastFocusedElement) {
            lastFocusedElement.focus();
            lastFocusedElement = null;
          }
        }
      }
    });
  });

  observer.observe(cartPopup, { attributes: true, attributeFilter: ['class'] });
});

document.addEventListener('DOMContentLoaded', function () {
  const zoomInButton = document.querySelector('.product__zoom-arrow');
  const featuredProductImage = document.querySelector('.product__image .responsive-image__image');

  if (!zoomInButton || !featuredProductImage) return;

  zoomInButton.setAttribute('tabindex', '0');
  zoomInButton.setAttribute('role', 'button');
  zoomInButton.setAttribute('aria-label', 'Zoom in product image');

  zoomInButton.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();

      const clickEvent = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true
      });

      featuredProductImage.dispatchEvent(clickEvent);
    }
  });
});

/**
 * Accessibility Fix for Exit-Intent Modal in Shopify
 * --------------------------------------------------
 * This script ensures that when the exit-intent newsletter modal appears:
 * 1. Keyboard focus is programmatically moved into the modal.
 * 2. Focus is trapped inside the modal until it is closed.
 * 3. Pressing "Escape" closes the modal and returns focus to the trigger.
 * 4. Background content is made inaccessible to screen readers while modal is open.
 *
 * How to use:
 * - Include this script in your Shopify theme's assets and load it before </body>.
 * - Ensure your modal has the class `.exit-intent__content` and contains
 *   focusable elements (like inputs and buttons).
 * - Call `ExitIntentA11y.open()` whenever your modal should appear.
 */

document.addEventListener('DOMContentLoaded', function () {
  const modal = document.querySelector('.exit-intent__content');
  if (!modal) return;

  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'textarea',
    'input:not([disabled])',
    'select:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  let lastFocusedElement = null;
  let trapped = false;

  function getFocusable() {
    return Array.from(modal.querySelectorAll(focusableSelector))
      .filter(el => el.offsetParent !== null || el === document.activeElement);
  }

  function openModal() {
    if (!modal.hasAttribute('data-open')) {
      lastFocusedElement = document.activeElement;
      modal.removeAttribute('hidden');
      modal.setAttribute('data-open', 'true');

      // Prevent background scroll
      document.body.style.overflow = 'hidden';

      // Hide background content from screen readers
      const main = document.getElementById('MainContent');
      if (main && 'inert' in main) main.inert = true;
      else if (main) main.setAttribute('aria-hidden', 'true');

      // Focus first focusable element or modal itself
      const email = modal.querySelector('#exit-intent-email');
      const first = email || getFocusable()[0] || modal;
      requestAnimationFrame(() => first.focus());

      if (!trapped) {
        document.addEventListener('keydown', onKeyDown, true);
        trapped = true;
      }
    }
  }

  function closeModal() {
    if (modal.hasAttribute('data-open')) {
      modal.setAttribute('hidden', '');
      modal.removeAttribute('data-open');

      document.body.style.overflow = '';

      const main = document.getElementById('MainContent');
      if (main && 'inert' in main) main.inert = false;
      else if (main) main.removeAttribute('aria-hidden');

      document.removeEventListener('keydown', onKeyDown, true);
      trapped = false;

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    }
  }

  function onKeyDown(e) {
    if (!modal.hasAttribute('data-open')) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      closeModal();
      return;
    }

    if (e.key === 'Tab') {
      const focusable = getFocusable();
      if (focusable.length === 0) {
        e.preventDefault();
        modal.focus();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  // Close button event
  const closeBtn = modal.querySelector('.exit-intent__close');
  if (closeBtn) closeBtn.addEventListener('click', closeModal);

  // Expose functions globally so you can trigger the modal
  window.ExitIntentA11y = { open: openModal, close: closeModal };

  // Example: trigger modal after 5 seconds
  // setTimeout(openModal, 5000);
});

/**
 * Adds accessibility-friendly pause/play buttons to all autoplay videos on the page.
 * - Finds all <video> elements with autoplay enabled (attribute or property).
 * - Injects a pause/play button for each video.
 * - Respects user "prefers-reduced-motion" setting by disabling autoplay.
 * - Excludes videos with the attribute `data-no-autoplay-toggle`.
 * - Keeps button state synced if video is played/paused externally.
 *
 * Usage:
 *   Call `addAutoplayVideoToggles();` after the DOM is ready.
 *   Example:
 *     document.addEventListener('DOMContentLoaded', addAutoplayVideoToggles);
 */
function addAutoplayVideoToggles() {
  const BUTTON_CLASS = 'a11y-video-toggle';
  const EXCLUDE_SELECTOR = '[data-no-autoplay-toggle]';
  const shouldReduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Inject minimal styles
  const css = `
    .${BUTTON_CLASS}{
      position:absolute; right:16px; bottom:16px;
      z-index:1000; display:inline-flex; align-items:center; gap:.5rem;
      padding:.5rem .75rem; font:inherit; line-height:1; cursor:pointer;
      border:0; border-radius:999px; background:rgba(0,0,0,.6); color:#fff;
      box-shadow:0 2px 10px rgba(0,0,0,.25)
    }
    .${BUTTON_CLASS}:focus{ outline:2px solid #fff; outline-offset:2px }
    .${BUTTON_CLASS}[data-state="paused"] .icon-play{ display:inline }
    .${BUTTON_CLASS}[data-state="paused"] .icon-pause{ display:none }
    .${BUTTON_CLASS}[data-state="playing"] .icon-play{ display:none }
    .${BUTTON_CLASS}[data-state="playing"] .icon-pause{ display:inline }
    .video-toggle-wrap{ position:relative }
    .${BUTTON_CLASS} svg{ width:16px; height:16px; }
  `;
  const style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function ensurePositioned(el) {
    const cs = getComputedStyle(el);
    if (cs.position === 'static') el.classList.add('video-toggle-wrap');
  }

  function makeButton() {
    const btn = document.createElement('button');
    btn.className = BUTTON_CLASS;
    btn.type = 'button';
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', 'Pause background video');
    btn.innerHTML = `
      <svg class="icon-play" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M8 5v14l11-7z"/></svg>
      <svg class="icon-pause" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M6 5h4v14H6zm8 0h4v14h-4z"/></svg>
      <span class="label">Pause</span>
    `;
    return btn;
  }

  function setState(btn, state) {
    btn.dataset.state = state;
    const playing = state === 'playing';
    btn.setAttribute('aria-pressed', String(!playing));
    btn.querySelector('.label').textContent = playing ? 'Pause' : 'Play';
    btn.setAttribute('aria-label', playing ? 'Pause background video' : 'Play background video');
  }

  function enhanceVideo(video) {
    if (video.dataset.a11yHasToggle) return;
    if (video.matches(EXCLUDE_SELECTOR)) return;

    if (shouldReduceMotion) {
      try { video.pause(); } catch(e) {}
      video.autoplay = false;
      video.removeAttribute('autoplay');
    }

    const parent = video.parentElement || video;
    ensurePositioned(parent);

    const btn = makeButton();
    setState(btn, video.paused ? 'paused' : 'playing');

    btn.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(()=>{});
        setState(btn, 'playing');
      } else {
        video.pause();
        setState(btn, 'paused');
      }
    });

    video.addEventListener('play',  () => setState(btn, 'playing'));
    video.addEventListener('pause', () => setState(btn, 'paused'));

    parent.appendChild(btn);
    video.dataset.a11yHasToggle = 'true';
  }

  function scan() {
    const vids = Array.from(document.querySelectorAll('video'))
      .filter(v => (v.hasAttribute('autoplay') || v.autoplay) && !v.dataset.a11yHasToggle);
    vids.forEach(enhanceVideo);
  }

  scan();

  // Watch for dynamically added videos
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      m.addedNodes && m.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('video')) {
          if (node.autoplay || node.hasAttribute('autoplay')) enhanceVideo(node);
        }
        node.querySelectorAll && node.querySelectorAll('video').forEach(v => {
          if (v.autoplay || v.hasAttribute('autoplay')) enhanceVideo(v);
        });
      });
    }
  });
  mo.observe(document.documentElement, { childList:true, subtree:true });
}


document.addEventListener('DOMContentLoaded', addAutoplayVideoToggles);


/**
 * mergeProductLinks
 * -----------------
 * Merges separate image and title links into a single anchor per product card,
 * so assistive tech announces one meaningful link (image + title + price).
 *
 * How it works:
 *  - Locates product tiles inside a container selector.
 *  - Takes the existing <a> around the image as the single link.
 *  - Moves the title node (and price block) inside that anchor.
 *  - Sets aria-labelledby to include title and price for clarity.
 *  - Leaves hover images decorative (alt="", aria-hidden, role="presentation").
 *
 * Options:
 *   rootSelector: limit scope (default '.featured-collection')
 *   tileSelector: product tile root (default '.featured-collection__item .product-tile')
 *   titleLinkSelector: selector for the separate title link (default 'h3 a')
 *   priceSelector: selector for the price container (default: '.meta')
 */

function mergeProductLinks(opts = {}) {
  const {
    rootSelector = '.featured-collection',
    tileSelector = '.featured-collection__item .product-tile',
    titleLinkSelector = 'h3 a',
    priceSelector = '.meta'
  } = opts;

  const roots = document.querySelectorAll(rootSelector);
  if (!roots.length) return;

  roots.forEach(root => {
    root.querySelectorAll(tileSelector).forEach(tile => {
      const imageLink = tile.querySelector('.product-tile__images a, a');
      if (!imageLink) return;

      const card = tile.closest('.featured-collection__item');
      const titleLink = card ? card.querySelector(titleLinkSelector) : null;
      const price = card ? card.querySelector(priceSelector) : null;

      tile.querySelectorAll('.product-tile__image.not-first img').forEach(img => {
        img.setAttribute('alt','');
        img.setAttribute('aria-hidden','true');
        img.setAttribute('role','presentation');
      });

      if (titleLink) {
        const titleText = titleLink.textContent.trim();
        const heading = document.createElement('h3');
        const titleId = titleLink.id || ('title-' + Math.random().toString(36).slice(2));
        heading.id = titleId;
        heading.className = 'type-body-regular mt3 mb0';
        heading.textContent = titleText;

        imageLink.appendChild(heading);

        const titleParent = titleLink.parentElement;
        titleLink.replaceWith(document.createTextNode(''));
        if (titleParent && !titleParent.textContent.trim()) titleParent.remove();

        if (price) {
          const priceId = price.id || ('price-' + Math.random().toString(36).slice(2));
          price.id = priceId;
          imageLink.after(price);
          imageLink.setAttribute('aria-labelledby', `${titleId} ${priceId}`);

          if (!price.querySelector('.visually-hidden')) {
            const vh = document.createElement('span');
            vh.className = 'visually-hidden';
            vh.textContent = 'Price: ';
            price.prepend(vh);
          }
        }

        imageLink.classList.add('product-card__link');
        imageLink.style.display = 'block';
        imageLink.style.textDecoration = 'none';
        imageLink.style.color = 'inherit';
      }
    });
  });
}


// Call after DOM ready
document.addEventListener('DOMContentLoaded', () => {
  mergeProductLinks();
});


/**
 * fillProductThumbnailAlt
 * -----------------------
 * Adds meaningful alt text to product thumbnails when missing.
 *
 * How it works:
 *  - Looks for `.product_thumbnail-list img` with empty/missing alt.
 *  - Uses the main product title text (from `.product__title`) as base.
 *  - Appends a descriptor like "Main view", "View 2", etc.
 *  - Does not overwrite existing alt values.
 *
 * Usage:
 *  document.addEventListener('DOMContentLoaded', fillProductThumbnailAlt);
 */
function fillProductThumbnailAlt() {
  const productTitle = document.querySelector('.product__title')?.textContent?.trim() || 'Product image';
  const thumbnails = document.querySelectorAll('.product_thumbnail-list img');

  thumbnails.forEach((img, index) => {
    const currentAlt = img.getAttribute('alt');
    if (!currentAlt || currentAlt.trim() === '') {
      const viewLabel = index === 0 ? 'Main view' : `View ${index + 1}`;
      img.setAttribute('alt', `${productTitle} - ${viewLabel}`);
    }
  });
}

document.addEventListener('DOMContentLoaded', fillProductThumbnailAlt);

document.addEventListener('DOMContentLoaded', function () {
  const modal = document.querySelector('.exit-intent');
  let lastFocusedElement = null;

  if (!modal) return;

  function trapFocus(e) {
    if (e.key === 'Tab') {
      const focusableEls = modal.querySelectorAll(
        'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
      );
      const firstFocusableEl = focusableEls[0];
      const lastFocusableEl = focusableEls[focusableEls.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === firstFocusableEl) {
          e.preventDefault();
          lastFocusableEl.focus();
        }
      } else {
        if (document.activeElement === lastFocusableEl) {
          e.preventDefault();
          firstFocusableEl.focus();
        }
      }
    }

    if (e.key === 'Escape') {
      closeModal();
    }
  }

  function openModal() {
    lastFocusedElement = document.activeElement;
    modal.setAttribute('tabindex', '-1');
    modal.focus();
    document.addEventListener('keydown', trapFocus);
  }

  function closeModal() {
    modal.classList.remove('active');
    document.removeEventListener('keydown', trapFocus);
    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === 'class') {
        const isActive = modal.classList.contains('active');
        if (isActive) {
          openModal();
        } else {
          closeModal();
        }
      }
    });
  });

  observer.observe(modal, { attributes: true, attributeFilter: ['class'] });
});


document.addEventListener("DOMContentLoaded", () => {
  const cartCount = document.querySelector(".js-cart-count");
  const cartToggle = document.querySelector(".js-cart-drawer-toggle");

  if (!cartCount || !cartToggle) return;

  // Function that updates the aria-label on the toggle
  const updateLabel = () => {
    const count = parseInt(cartCount.textContent.trim(), 10) || 0;
    cartToggle.setAttribute(
      "aria-label",
      count === 0
        ? "Open cart, cart is empty"
        : count === 1
          ? "Open cart, 1 item"
          : `Open cart, ${count} items`
    );
  };

  // Initialize
  updateLabel();

  // Observer for changes to the counter
  const observer = new MutationObserver(() => updateLabel());

  observer.observe(cartCount, {
    childList: true,
    characterData: true,
    subtree: true
  });
});



document.addEventListener('DOMContentLoaded', function () {
  const testimonialsContainer = document.querySelector('.js-fq');
  const slides = testimonialsContainer ? testimonialsContainer.children : [];
  const prevBtn = document.querySelector('.testimonials-prev');
  const nextBtn = document.querySelector('.testimonials-next');

  if (slides.length <= 1) {
    Array.from(slides).forEach(slide => {
      slide.removeAttribute('role');
      slide.removeAttribute('tabindex');
      slide.removeAttribute('aria-selected');
      slide.removeAttribute('aria-hidden');
    });

    if (prevBtn) {
      prevBtn.style.display = 'none';
      prevBtn.setAttribute('aria-hidden', 'true');
      prevBtn.tabIndex = -1;
    }
    if (nextBtn) {
      nextBtn.style.display = 'none';
      nextBtn.setAttribute('aria-hidden', 'true');
      nextBtn.tabIndex = -1;
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const nav = document.querySelector('.nav'); // menu container
  if (!nav) return;

  // Create sr-only div for accessible narration
  let srLive = document.createElement('div');
  srLive.className = 'sr-only';
  srLive.setAttribute('aria-live', 'assertive');
  srLive.setAttribute('role', 'status');
  document.body.appendChild(srLive);

  // Function that updates aria-expanded and sr-live based on class
  const updateAriaAndSR = (link) => {
    const isActive = link.classList.contains('nav__menu--active');
    link.setAttribute('aria-expanded', isActive ? 'true' : 'false');

    const submenuLabel = link.textContent.trim() || 'Submenu';
    if (isActive) {
      srLive.textContent = `${submenuLabel} submenu opened`;
    } else {
      srLive.textContent = `${submenuLabel} submenu closed`;
    }
  };

  // Observe all links that may have a submenu
  const links = nav.querySelectorAll('.nav__link-parent');

  links.forEach(link => {
    // Initialize aria-expanded
    link.setAttribute('aria-expanded', link.classList.contains('nav__menu--active') ? 'true' : 'false');

    const observer = new MutationObserver(() => updateAriaAndSR(link));

    observer.observe(link, {
      attributes: true,
      attributeFilter: ['class']
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const interval = setInterval(function () {
    const thumbs = document.querySelectorAll('.gf-range-slider [role="slider"]');
    if (thumbs.length >= 2) {
      thumbs[0].setAttribute('aria-label', 'Minimum Price');
      thumbs[1].setAttribute('aria-label', 'Maximum Price');
      clearInterval(interval);
    }
  }, 300);
});

document.addEventListener("DOMContentLoaded", () => {
  const skipLink = document.querySelector(".skip-link");
  const main = document.querySelector("#home");

  if (skipLink && main) {
    skipLink.addEventListener("click", (e) => {
      e.preventDefault();
      const focusableSelectors = [
        'a[href]',
        'button:not([disabled])',
        'textarea:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        '[tabindex]:not([tabindex="-1"])'
      ];
      const firstFocusable = main.querySelector(focusableSelectors.join(','));
      if (firstFocusable) {
        firstFocusable.focus();
      } else {
        main.setAttribute("tabindex", "-1");
        main.focus();
      }
    });
  }
});

/*
document.addEventListener("DOMContentLoaded", () => {
  const popup = document.querySelector(".exit-intent");
  const closeBtn = popup.querySelector(".exit-intent__close");
  const emailInput = popup.querySelector('.exit-intent__form input[type="email"]');
  const submitBtn = popup.querySelector(".exit-intent__button");
  const skipLink = document.querySelector(".skip-link");

  const focusable = [closeBtn, emailInput, submitBtn];

  const trapFocus = (e) => {
    if (!popup.classList.contains("visible")) return; // check for visible class

    if (e.key === "Tab") {
      e.preventDefault();
      const index = focusable.indexOf(document.activeElement);
      if (e.shiftKey) {
        const prevIndex = (index - 1 + focusable.length) % focusable.length;
        focusable[prevIndex].focus();
      } else {
        const nextIndex = (index + 1) % focusable.length;
        focusable[nextIndex].focus();
      }
    } else if (e.key === "Escape") {
      closePopup();
    }
  };

  const openPopup = () => {
    popup.setAttribute("aria-hidden", "false");
    popup.classList.add("visible");
    popup.classList.add("active");
    emailInput.focus();

    // activate trapFocus only when visible
    document.addEventListener("keydown", trapFocus);
  };


  const apparitionDelay = parseInt(
    popup.dataset.sectionSettings?.match(/"apparitionDelay":\s*(\d+)/)?.[1] || 0,
    10
  ) * 1000;

  setTimeout(openPopup, apparitionDelay);
});*/


document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const collectionItems = document.querySelector('.gf-summary');
    if( !collectionItems ) return;
  
    collectionItems.setAttribute('aria-live', 'assertive');
  }, 1000);
});